import { useCallback } from 'react';

import * as server from '../server';

export const useCancelWithdraw = () => {
    return useCallback(async ({
        transactionCode,
        reason
    }) => {
        await server.cancelWithdraw({
            transactionCode,
            reason
        });
    }, []);
};
